<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>人脸识别</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card class="box-card">
            <el-form :inline="true" :model="logsForm" class="demo-form-inline">
                <el-form-item label="">
                    <el-input v-model="logsForm.idcardname" @keyup.enter.native="clicksearch" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clicksearch">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表 -->
            <el-table :data="logList" border stripe>
                <el-table-column prop="Orderno" label="订单号"></el-table-column>
                <el-table-column prop="Idcardno" label="身份证号码"></el-table-column>
                <el-table-column prop="Idcardname" label="身份证姓名"></el-table-column>
                <el-table-column prop="Statuss" label="状态"></el-table-column>
                <el-table-column prop="Liverate" label="活体检测得分"></el-table-column>
                <el-table-column prop="Similarity" label="人脸比对得分"></el-table-column>
                <el-table-column prop="" label="图片预览">
                  <template v-slot="scope">
                    <img :src="scope.row.Photourl" min-width="48" height="64" />
                  </template>
                </el-table-column>
                <el-table-column prop="" label="最佳照片">
                  <template v-slot="scope">
                    <el-link  size="mini" style="margin-left: 0; margin-right: 5px;color: #48c9b0;font-weight:bold;" :href="scope.row.Photourl" target="_blank">查看照片</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="最佳视频">
                  <template v-slot="scope">
                    <el-link  size="mini" style="margin-left: 0; margin-right: 5px;color: #48c9b0;font-weight:bold;" :href="scope.row.Videourl" target="_blank">查看视频</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="Createtime" label="创建时间"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pages">
                <el-pagination
                @current-change="handleCurrentPageChange"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="listnum">
                </el-pagination>
            </div>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyFaceidLogs',
  data () {
    return {
      logsForm: {
        idcardname: ''
      },
      logList: [],
      listnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetfaceidloglist()
    this.apiGetfaceidlognum()
  },
  methods: {
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetfaceidloglist()
      this.apiGetfaceidlognum()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.selectedPageNo = selectedPageNo
      this.apiGetfaceidloglist()
      this.apiGetfaceidlognum()
    },
    apiGetfaceidlognum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        idcardname: that.logsForm.idcardname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getfaceidlognum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.listnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetfaceidloglist: function (pageno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        idcardname: that.logsForm.idcardname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getfaceidloglist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.logList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
